import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { fetchLlamaStatus } from "../lib/live-api";
import { queryKeys } from "../lib/query-client";

const STORAGE_KEY = "skill-grinder-llm-model";
const FALLBACK_MODELS = ["Qwen3-4B-Q4_K_M.gguf"];

export function useLlmModel() {
  const { data: llama } = useQuery({
    queryKey: queryKeys.llama,
    queryFn: fetchLlamaStatus,
    staleTime: 120_000,
    retry: false,
  });

  const models = llama?.models?.length
    ? llama.models
    : llama?.defaultModel
      ? [llama.defaultModel, ...FALLBACK_MODELS.filter((m) => m !== llama.defaultModel)]
      : FALLBACK_MODELS;

  const defaultModel = llama?.defaultModel ?? FALLBACK_MODELS[0];

  const [model, setModelState] = useState(() => {
    if (typeof window === "undefined") return defaultModel;
    return localStorage.getItem(STORAGE_KEY) || defaultModel;
  });

  useEffect(() => {
    if (!models.includes(model) && models[0]) {
      setModelState(models[0]);
    }
  }, [models, model]);

  function setModel(next: string) {
    setModelState(next);
    localStorage.setItem(STORAGE_KEY, next);
  }

  return { model, setModel, models, defaultModel, llamaOk: llama?.ok ?? false };
}